export const conversationTypes = {
  CONVERSATION_ONCHANGE: "CONVERSATION_ONCHANGE",
  ON_CHANGE_Basic_Conversation_FIELD:"ON_CHANGE_Basic_Conversation_FIELD",
  RESET_CONVERSATION_DATA:"RESET_CONVERSATION_DATA",
};
